import * as mutationTypes from './mutation-types'
import { requestStatus } from '../../../../constants/comms'

const Ui = {
  state() {
    return {
      showingCompletedTodos: false,
      showingCompletedCheckLists: false,
      showingCompletedChecksInCheckListIds: [],
      newCommentRemarkIds: [],
      newCommentCheckIds: [],
      newCommentAssistantCheckIds: [],
      editCommentIds: [],
      mentionUsernames: [],
      pulseUsernames: [],
      fetchingCommunicationsStatus: requestStatus.INITIAL,
    }
  },
  getters: {
    fetchingCommunicationsInProgress: (state) => {
      return state.fetchingCommunicationsStatus === requestStatus.IN_PROGRESS
    },
  },
  mutations: {
    [mutationTypes.TOGGLE_SHOWING_COMPLETED_TODOS](state) {
      state.showingCompletedTodos = !state.showingCompletedTodos
    },

    [mutationTypes.TOGGLE_SHOWING_COMPLETED_CHECK_LISTS](state) {
      state.showingCompletedCheckLists = !state.showingCompletedCheckLists
    },

    [mutationTypes.ADD_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID](
      state,
      checkListId
    ) {
      state.showingCompletedChecksInCheckListIds.push(checkListId)
    },

    [mutationTypes.REMOVE_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID](
      state,
      checkListId
    ) {
      const index =
        state.showingCompletedChecksInCheckListIds.indexOf(checkListId)
      state.showingCompletedChecksInCheckListIds.splice(index, 1)
    },

    [mutationTypes.ADD_NEW_COMMENT_REMARK_ID](state, id) {
      state.newCommentRemarkIds = state.newCommentRemarkIds.concat([id])
    },

    [mutationTypes.ADD_NEW_COMMENT_CHECK_ID](state, id) {
      state.newCommentCheckIds = state.newCommentCheckIds.concat([id])
    },

    [mutationTypes.ADD_NEW_COMMENT_ASSISTANT_CHECK_ID](state, id) {
      state.newCommentAssistantCheckIds =
        state.newCommentAssistantCheckIds.concat([id])
    },

    [mutationTypes.REMOVE_NEW_COMMENT_REMARK_ID](state, remarkId) {
      const index = state.newCommentRemarkIds.indexOf(remarkId)
      state.newCommentRemarkIds.splice(index, 1)
    },

    [mutationTypes.REMOVE_NEW_COMMENT_CHECK_ID](state, checkId) {
      const index = state.newCommentCheckIds.indexOf(checkId)
      state.newCommentCheckIds.splice(index, 1)
    },

    [mutationTypes.REMOVE_NEW_COMMENT_ASSISTANT_CHECK_ID](state, id) {
      const index = state.newCommentAssistantCheckIds.indexOf(id)
      state.newCommentAssistantCheckIds.splice(index, 1)
    },

    [mutationTypes.ADD_EDIT_COMMENT_ID](state, id) {
      state.editCommentIds = state.editCommentIds.concat([id])
    },

    [mutationTypes.REMOVE_EDIT_COMMENT_ID](state, id) {
      const index = state.editCommentIds.indexOf(id)
      state.editCommentIds.splice(index, 1)
    },

    [mutationTypes.SET_MENTION_USERNAMES](state, userNames) {
      state.mentionUsernames = userNames
    },

    [mutationTypes.SET_PULSE_USERNAMES](state, userNames) {
      state.pulseUsernames = userNames
    },

    [mutationTypes.RESET_MENTION_USERNAMES](state) {
      state.mentionUsernames = []
      state.pulseUsernames = []
    },

    [mutationTypes.START_FETCHING_COMMUNICATIONS](state) {
      state.fetchingCommunicationsStatus = requestStatus.IN_PROGRESS
    },

    [mutationTypes.STOP_FETCHING_COMMUNICATIONS](state) {
      state.fetchingCommunicationsStatus = requestStatus.COMPLETED
    },

    [mutationTypes.RESET_FETCHING_COMMUNICATIONS](state) {
      state.fetchingCommunicationsStatus = requestStatus.INITIAL
    },
  },

  actions: {
    toggleCompletedTodos({ commit }) {
      commit(mutationTypes.TOGGLE_SHOWING_COMPLETED_TODOS)
    },

    toggleCompletedCheckLists({ commit }) {
      commit(mutationTypes.TOGGLE_SHOWING_COMPLETED_CHECK_LISTS)
    },

    toggleCompletedChecksInCheckList({ commit, state }, checkListId) {
      if (
        state.showingCompletedChecksInCheckListIds.indexOf(checkListId) > -1
      ) {
        commit(
          mutationTypes.REMOVE_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID,
          checkListId
        )
      } else {
        commit(
          mutationTypes.ADD_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID,
          checkListId
        )
      }
    },

    addNewCommentRemarkId({ commit }, remarkId) {
      commit(mutationTypes.ADD_NEW_COMMENT_REMARK_ID, remarkId)
    },

    removeNewCommentRemarkId({ commit }, remarkId) {
      commit(mutationTypes.REMOVE_NEW_COMMENT_REMARK_ID, remarkId)
    },

    addNewCommentCheckId({ commit }, checkId) {
      commit(mutationTypes.ADD_NEW_COMMENT_CHECK_ID, checkId)
    },

    addEditCommentId({ commit }, commentId) {
      commit(mutationTypes.ADD_EDIT_COMMENT_ID, commentId)
    },

    removeEditCommentId({ commit }, commentId) {
      commit(mutationTypes.REMOVE_EDIT_COMMENT_ID, commentId)
    },

    addNewCommentAssistantCheckId({ commit }, assistantCheckId) {
      commit(mutationTypes.ADD_NEW_COMMENT_ASSISTANT_CHECK_ID, assistantCheckId)
    },

    removeNewCommentAssistantCheckId({ commit }, assistantCheckId) {
      commit(
        mutationTypes.REMOVE_NEW_COMMENT_ASSISTANT_CHECK_ID,
        assistantCheckId
      )
    },
  },
}

export default Ui
